import React from "react";
import TableWrapper from "../Table/tableWrapper";
import {useSelector} from "react-redux";
import MonthSelector from "./monthSelector";
import { calculateDiscountAmount, createTableHeadersAndData } from "../../Util/TableHelpers/commonHelper";
import { calculateAmountAfterDiscount, isCurrentMonth } from "../../Util/filter";
import StoreUsageCSVDownloader from "./storeUsageCSVDownloader";
import { plansSelector } from "../../Reducers/plansReducer";
import PlanBadge from "../CommonComponents/planBadge";

const columnConfigs = [
    {
        id: "companyName",
        name: "Company Name",
        dataFunc: ({accountData}) => accountData.companyName
    },
    {
        id: "adminName",
        name: "Admin Name", 
        dataFunc: ({accountData}) => accountData.adminName
    },
    {
        id: "adminEmail",
        name: "Admin Email",
        dataFunc: ({accountData}) => accountData.email
    },
    {
        id: "phoneNumber",
        name: "Phone Number",
        dataFunc: ({accountData}) => accountData.phoneNumber
    },
    {
        id: "country",
        name: "Country",
        dataFunc: ({accountData}) => accountData.country
    },
    {
        id: "currentPlan",
        name: "Current Plan",
        dataFunc: ({accountData}) => <PlanBadge planRaw={accountData.currentPlanRaw} />
    },
    {
        id: "totalOrders",
        name: "Total Orders",
        dataFunc: ({paymentDataEntry}) => paymentDataEntry.numberOfOrders
    },
    {
        id: "totalPaidOrders",
        name: "Total Paid Orders",
        dataFunc: ({paymentDataEntry}) => paymentDataEntry.numberOfPaidOrders
    },
    {
        id: "totalAmount",
        name: "Total Amount($)",
        dataFunc: ({paymentDataEntry}) => paymentDataEntry.billableAmount
    },
    {
        id: "discountAmount",
        name: "Discount Amount($)",
        dataFunc: ({paymentDataEntry, discount}) => calculateDiscountAmount(paymentDataEntry.billableAmount, discount)
    },
    {
        id: "totalPayableAmount",
        name: "Total Payable Amount($)",
        dataFunc: ({paymentDataEntry, discount}) => calculateAmountAfterDiscount(paymentDataEntry.billableAmount, discount)
    },
    {
        id: "paymentStatus",
        name: "Payment Status",
        dataFunc: ({paymentDataEntry, plans, accountData}) => {
            if (!plans.isPaid(accountData.currentPlanRaw)) return "N/A";
            return <div className={paymentDataEntry.isPaid ? "green-button" : "red-button"}>
                {paymentDataEntry.isPaid ? "Paid" : "Unpaid"}
            </div>;
        }
    },
    {
        id: "download",
        name: "",
        dataFunc: ({accountData, date}) => <StoreUsageCSVDownloader accountDetails={accountData} date={date}/>
    }
];

const StoreUsageTableSection = () => {
    const billingDataObj = useSelector(state => state.partnerBillingData);
    const partnerAccountsObj = useSelector(state => state.partnerAccounts);
    const partnerDetails = useSelector(state => state.partnerDetails);
    const selectedMonth = useSelector(state => state.storeUsageMonth);
    const plansObj = useSelector(plansSelector);

    if (billingDataObj === null || partnerDetails == null || partnerAccountsObj == null) {
        const {headers, data} = createTableHeadersAndData([], columnConfigs);
        return (
            <div className="p-2 ps-0 min-width-md-parent">
                <span className="sub-title">Usage Breakdown</span>
                <TableWrapper tableHeaderArr={headers} tableBodyArr={data}
                              errorText="You do not have any usage"/>
            </div>
        );
    }


    const tableInput = billingDataObj.billingFormattedObj[selectedMonth]?.billingInfos?.map(entry => {
        return {
            paymentDataEntry: entry,
            accountData: partnerAccountsObj.accountsObj[entry.companyId],
            discount: partnerDetails.billingDiscountAmount,
            date: selectedMonth,
            plans: plansObj
        }
    })

    const processedColumnConfigs = isCurrentMonth(selectedMonth) ? 
        columnConfigs.filter(config => config.id !== "paymentStatus") : 
        columnConfigs;

    const {headers, data} = createTableHeadersAndData(tableInput, processedColumnConfigs);

    return (
        <div className="p-2 ps-0 min-width-md-parent">
            <div className="d-flex justify-content-between">
                <span className="sub-title">Usage Breakdown</span>
                <MonthSelector/>
            </div>
            <TableWrapper tableHeaderArr={headers} tableBodyArr={data} option={{}}/>
        </div>
    )
}

export default StoreUsageTableSection;
